export enum uiLoggerName {
  ui_OwnConfigOpen = "ui-OwnConfigOpen",
  ui_OwnConfigClose = "ui-OwnConfigClose",
  ui_BpConfigOpen = "ui-BpConfigOpen",
  ui_BpConfigClose = "ui-BpConfigClose",
  ui_OwnSanitizerOpen = "ui-OwnSanitizerOpen",
  ui_OwnSanitizerClose = "ui-OwnSanitizerClose",
  ui_BpSanitizerOpen = "ui-BpSanitizerOpen",
  ui_BpSanitizerClose = "ui-BpSanitizerClose",
  ui_OwnAutoConfigOpen = "ui-OwnAutoConfigOpen",
  ui_OwnAutoConfigClose = "ui-OwnAutoConfigClose",
  ui_BpAutoConfigOpen = "ui-BpAutoConfigOpen",
  ui_BpAutoConfigClose = "ui-BpAutoConfigClose",
  ui_BpSelected = "ui-BpSelected",
  ui_ReconcileLedgerButton = "ui-ReconcileLedgerButton",
  ui_DownloadResultsButtonClicked = "ui-DownloadResultsButtonClicked",
  ui_UploadOwnLedger = "ui-UploadOwnLedger",
  ui_UploadPartnerLedger = "ui-UploadPartnerLedger",
  ui_ManualReconOpen = "ui-ManualReconOpen",
  ui_ManualReconClose = "ui-ManualReconClose",

  // Partner Comms events
  ui_PartnerCommunicationSelected = "ui-PartnerCommunicationSelected",
  ui_BCSelected = "ui-BCSelected",
  ui_LRSelected = "ui-LRSelected",
  ui_RefreshStatus = "ui-RefreshStatus",
  ui_ClickedOnSetting = "ui-ClickedOnSetting",
  ui_ResetStatus = "ui-ResetStatus",
  ui_AutoResetStatus_Yes = "ui-AutoResetStatus-Yes",
  ui_AutoResetStatus_No = "ui-AutoResetStatus-No",
  ui_SendReminderSettingChange_Yes = "ui-SendReminderSettingChange_Yes",
  ui_SendReminderSettingChange_No = "ui-SendReminderSettingChange_No",
  ui_ClickedOnFilter = "ui-ClickedOnFilter",
  ui_FilterApplied = "ui-FilterApplied",
  ui_clickedOnBulkEmail = "ui-ClickedOnBulkEmail",
  ui_BulkEmailSent = "ui-BulkEmailSent",
  ui_TemplateCreatedOnMain = "ui-TemplateCreatedOnMain",
  ui_TemplateCreatedOnEmailModal = "ui-TemplateCreatedOnEmailModal",
  ui_DownloadReport = "ui-DownloadReport",
  ui_SingleEmailSent = "ui-SingleEmailSent",
  ui_UpdatedEmailTemplate = "ui-UpdatedEmailTemplate",
  ui_ViewEmailClicked = "ui-ViewEmailClicked",
  ui_DownloadLedgerStatus = "ui-DownloadLedgerStatus",
  ui_DownloadLedgerIcon = "ui-DownloadLedgerIcon",
  ui_DownloadLedgerViewEmail = "ui-DownloadLedgerViewEmail",
  ui_ClosingBalanceRefresh = "ui-ClosingBalanceRefresh",
  // end of Partner Comms events
}

export const uiLoggerNamesPartnerCommunication = {
  UI_PC_BCB_ACTIONS_MOVETASKTORECON_CLICK: {
    functionName: "UI-PC-BCB-Actions-MoveTaskToRecon-Click",
    message: "Clicks on Move Task to Recon button",
  },
  UI_PC_BCB_ACTIONS_MOVETASKTORECON_MOVE_CLICK: {
    functionName: "UI-PC-BCB-Actions-MoveTaskToRecon-Move-Click",
    message: "Task moved to recon successfully",
  },
  UI_PC_BCB_ACTIONS_VIEWHISTORY_CLICK: {
    functionName: "UI-PC-BCB-Actions-ViewHistory-Click",
    message: "Views task history",
  },
  UI_PC_BCB_BULKACTION_BULKMOVETASKTORECON_CLICK: {
    functionName: "UI-PC-BCB-BulkAction-BulkMoveTaskToRecon-Click",
    message: "Clicks on Bulk Move Task to Recon button",
  },
  UI_PC_BCB_BULKACTION_BULKMOVETASKTORECON_VIEWTASKS_CLICK: {
    functionName: "UI-PC-BCB-BulkAction-BulkMoveTaskToRecon-ViewTasks-Click",
    message: "View Tasks that already exists for partners ",
  },
  UI_PC_BCB_BULKACTION_BULKMOVETASKTORECON_CONTINUE_CLICK: {
    functionName: "UI-PC-BCB-BulkAction-BulkMoveTaskToRecon-Continue-Click",
    message: "Clicks on continue after reviewing bulk tasks.",
  },
  UI_PC_BCB_BULKACTION_BULKMOVETASKTORECON_CONTINUE_MOVE_CLICK: {
    functionName: "UI-PC-BCB-BulkAction-BulkMoveTaskToRecon-Continue-Move-Click",
    message: "Task moved to recon successfully in bulk",
  },
  UI_PC_BCB_ACTIONS_CLOSEANDRESET_CLICK: {
    functionName: "UI-PC-BCB-Actions-CloseAndReset-Click",
    message: "Clicks on Close and Reset button",
  },
  UI_PC_BCB_ACTIONS_CLOSEANDRESET_PROCEED_CLICK: {
    functionName: "UI-PC-BCB-Actions-CloseAndReset-Proceed-Click",
    message: "Task closed and reset successfully",
  },
  UI_PC_BCB_ACTIONS_CLOSEANDRESET_CANCEL_CLICK: {
    functionName: "UI-PC-BCB-Actions-CloseAndReset-Cancel-Click",
    message: "Cancels closing and resetting of task",
  },
  UI_PC_BCB_BULKACTION_BULKCLOSEANDRESET_CLICK: {
    functionName: "UI-PC-BCB-BulkAction-BulkCloseAndReset-Click",
    message: "Clicks on Bulk Close and Reset button",
  },
  UI_PC_BCB_BULKACTION_BULKCLOSEANDRESET_CLOSEANDRESET_CLICK: {
    functionName: "UI-PC-BCB-BulkAction-BulkCloseAndReset-CloseAndReset-Click",
    message: "Closed and Reset tasks successfully in bulk",
  },
  UI_PC_BCB_APPROVERESPONSE_YES_CLICK: {
    functionName: "UI-PC-BCB-ApproveResponse-Yes-Click",
    message: "Clicked on Approve Response-Yes",
  },
  UI_PC_BCB_ATTACHMENTS_PDF_CLICK: {
    functionName: "UI-PC-BCB-Attachments-PDF-Click",
    message: "Clicked on download confirmation document",
  },
  UI_PC_BCB_ATTACHMENTS_LEDGERS_CLICK: {
    functionName: "UI-PC-BCB-Attachments-Ledgers-Click",
    message: "Clicked on download ledgers",
  },
  UI_PC_BCB_ATTACHMENTS_OPENITEMS_CLICK: {
    functionName: "UI-PC-BCB-Attachments-OpenItems-Click",
    message: "Clicked on download open items",
  },
  UI_PC_BCB_BULK_APPROVE_YES_CLICK: {
    functionName: "UI-PC-BCB-BulkApprove-Yes-Click",
    message: "Clicked on Bulk Approve-Yes",
  },
  UI_PC_BCB_BULK_MAIL_CLICK: {
    functionName: "UI-PC-BCB-BulkMail-Click",
    message: "Clicked on Bulk Send Mail",
  },
  UI_PC_BCB_BULK_MAIL_SEND_CLICK: {
    functionName: "UI-PC-BCB-BulkMail-Send-Click",
    message: "Clicked on Send on while sending Bulk Mails",
  },
  UI_PC_BCB_BULK_RESET_RESET_CLICK: {
    functionName: "UI-PC-BCB-BulkReset-Reset-Click",
    message: "Clicked on Bulk Close and Reset",
  },
  UI_PC_BCB_DOWNLOAD_REPORT_CLICK: {
    functionName: "UI-PC-BCB-DownloadReport-Click",
    message: "Clicked on Dowload report in More options",
  },
  UI_PC_BCB_FILTER_APPLY_CLICK: {
    functionName: "UI-PC-BCB-Filter-Apply-Click",
    message: "Clicked on Apply in filter",
  },
  UI_PC_BCB_PAGE_SELECT_MODE_CLICK: {
    functionName: "UI-PC-BCB-PageSelectMode-Click",
    message: "Clicked on Page Select Mode",
  },
  UI_PC_BCB_PARTNER_REQUESTS_CLICK: {
    functionName: "UI-PC-BCB-PartnerRequests-Click",
    message: "Clicked on Partner Requests",
  },
  UI_PC_BCB_PARTNER_REQUESTS_REPLY_SEND_CLICK: {
    functionName: "UI-PC-BCB-PartnerRequests-Reply-Send-Click",
    message: "Clicked on Send in Reply from Partner Requests",
  },
  UI_PC_BCB_PARTNER_REQUESTS_RESOLVED_CLICK: {
    functionName: "UI-PC-BCB-PartnerRequests-Resolved-Click",
    message: "Clicked on Mark as Resolved in Partner Requests",
  },
  UI_PC_BCB_SEND_VIEW_MAIL_CLICK: {
    functionName: "UI-PC-BCB-SendViewMail-Click",
    message: "Clicked on Send/View Mail",
  },
  UI_PC_BCB_SEND_FIRST_MAIL_CLICK: {
    functionName: "UI-PC-BCB-SendFirstMail-Click",
    message: "Clicked on Send while Sending first mail",
  },
  UI_PC_BCB_SEND_VIEW_MAIL_SEND_CLICK: {
    functionName: "UI-PC-BCB-SendViewMail-Send-Click",
    message: "Clicked on Send from Send/View Mail",
  },
  UI_PC_BCB_SEND_VIEW_MAIL_UPLOAD_FILE_CLICK: {
    functionName: "UI-PC-BCB-SendViewMail-UploadFile-Click",
    message: "Clicked on Upload file when sending Reply Mails",
  },
  UI_PC_BCB_SETTINGS_CLICK: {
    functionName: "UI-PC-BCB-Settings-Click",
    message: "Clicked on Settings in More options",
  },
  UI_PC_BCB_UPDATE_RESPONSE_YES_CLICK: {
    functionName: "UI-PC-BCB-UpdateResponse-Yes-Click",
    message: "Clicked on Update Response-Yes",
  },
  UI_PC_BCB_VIEW_HISTORY_CLICK: {
    functionName: "UI-PC-BCB-ViewHistory-Click",
    message: "Clicked on View History",
  },
  UI_PC_BCB_VIEW_RECON_CLICK: {
    functionName: "UI-PC-BCB-ViewRecon-Click",
    message: "Clicked on View Recon",
  },
  UI_PC_BCB_BULK_MAIL_VIEW_COMMUNICATION_CLICK: {
    functionName: "UI-PC-BCB-BulkMail-ViewCommunication-Click",
    message: "Clicked on View Communication type while sending bulk mail",
  },
  UI_PC_BCB_MANAGE_COMMUNICATION_NEW_CLICK: {
    functionName: "UI-PC-BCB-ManageCommunication-New-Click",
    message: "Clicked on New Communication type",
  },
  UI_PC_BCB_MULTIPLE_COMMUNICATIONS_PROCEED_CLICK: {
    functionName: "UI-PC-BCB-MultipleCommunicaitons-Proceed-Click",
    message: "Clicked on Proceed for multiple communications",
  },
} as const;

export const uiLoggerNamesRecon = {
  UI_PROD_LOGIN_CLICK: {
    functionName: "UI-Prod-Login-Click",
    message: "Prod Login",
  },
  UI_STAGE_LOGIN_CLICK: {
    functionName: "UI-Prod-Login-Click",
    message: "Stage Login",
  },
  UI_DEV_LOGIN_CLICK: {
    functionName: "UI-Prod-Login-Click",
    message: "Dev Login",
  },
  UI_WF_DB_SHOW_CLICK: {
    functionName: "UI-WF-DB-Show-Click",
    message: "Shows the home dashboard",
  },
  UI_RL_UPLOAD_OWN_LEDGER_CLICK: {
    functionName: "UI-RL-UploadOwnLedger-Click",
    message: "Upload own side ledger",
  },
  UI_RL_OWN_CONFIG_CLICK: {
    functionName: "UI-RL-Own-Config-Click",
    message: "Own side manual config",
  },
  UI_RL_OWN_CONFIG_CLOSE: {
    functionName: "UI-RL-Own-Config-Close",
    message: "Own side manual config close",
  },
  UI_RL_OWN_CONFIG_SAVE_AS_TEMPLATE_CLICK: {
    functionName: "UI-RL-Own-Config-SaveAsTemplate-Click",
    message: "Clicking on Save As Template in own side",
  },
  UI_RL_OWN_CONFIG_SAVE_AS_TEMPLATE_SAVE_NEW_CLICK: {
    functionName: "UI-RL-Own-Config-SaveAsTemplate-SaveNew-Click",
    message: "Actually saving template in own side",
  },
  UI_RL_OWN_CONFIG_SAVE_AS_TEMPLATE_UPDATE_EXISTING_CLICK: {
    functionName: "UI-RL-Own-Config-SaveAsTemplate-UpdateExisting-Click",
    message: "Updating template in own side",
  },
  UI_RL_OWN_CONFIG_TDS_TCS_APPLICABLE_CLICK: {
    functionName: "UI-RL-Own-Config-TDS/TCSApplicable-Click",
    message: "Clicking on TDS/TCS applicable",
  },
  UI_RL_OWN_CONFIG_TDS_TCS_APPLICABLE_UPDATE_CLICK: {
    functionName: "UI-RL-Own-Config-TDS/TCSApplicable-Update-Click",
    message: "Changing TDS/TCS percentage",
  },
  UI_RL_OWN_CONFIG_TDS_TCS_APPLICABLE_CANCEL_CLICK: {
    functionName: "UI-RL-Own-Config-TDS/TCSApplicable-Cancel-Click",
    message: "Cancel TDS/TCS percentage",
  },
  UI_RL_OWN_CONFIG_SANITIZER_CLICK: {
    functionName: "UI-RL-Own-Config-sanitizer-Click",
    message: "Using sanitizer own side",
  },
  UI_RL_OWN_CONFIG_SANITIZER_APPLY_CLICK: {
    functionName: "UI-RL-Own-Config-sanitizer-Apply-Click",
    message: "Applying sanitizer own side",
  },
  UI_RL_OWN_CONFIG_SANITIZER_CLOSE_CLICK: {
    functionName: "UI-RL-Own-Config-sanitizer-Close-Click",
    message: "Closing sanitizer window without applying",
  },
  UI_RL_OWN_CONFIG_NEXT_ADD_CLICK: {
    functionName: "UI-RL-Own-Config-Next-Add-Click",
    message: "Adding entry type in own side",
  },
  UI_RL_OWN_CONFIG_SAVE_CLICK: {
    functionName: "UI-RL-Own-Config-Save-Click",
    message: "Saving own side manual config",
  },
  UI_RL_UPLOAD_PARTNER_LEDGER_CLICK: {
    functionName: "UI-RL-UploadPartnerLedger-Click",
    message: "Upload partner side ledger",
  },
  UI_RL_PARTNER_CONFIG_CLICK: {
    functionName: "UI-RL-Partner-Config-Click",
    message: "Partner side manual config",
  },
  UI_RL_PARTNER_CONFIG_CLOSE: {
    functionName: "UI-RL-Partner-Config-Close",
    message: "Partner side manual config close",
  },
  UI_RL_PARTNER_CONFIG_SAVE_AS_TEMPLATE_CLICK: {
    functionName: "UI-RL-Partner-Config-SaveAsTemplate-Click",
    message: "Saving template in partner side",
  },
  UI_RL_PARTNER_CONFIG_SAVE_AS_TEMPLATE_SAVE_NEW_CLICK: {
    functionName: "UI-RL-Partner-Config-SaveAsTemplate-SaveNew-Click",
    message: "Actually saving template in partner side",
  },
  UI_RL_PARTNER_CONFIG_SAVE_AS_TEMPLATE_UPDATE_EXISTING_CLICK: {
    functionName: "UI-RL-Partner-Config-SaveAsTemplate-UpdateExisting-Click",
    message: "Updating template in partner side",
  },
  UI_RL_PARTNER_CONFIG_TDS_TCS_APPLICABLE_CLICK: {
    functionName: "UI-RL-Partner-Config-TDS/TCSApplicable-Click",
    message: "Clicking on TDS/TCS applicable",
  },
  UI_RL_PARTNER_CONFIG_TDS_TCS_APPLICABLE_UPDATE_CLICK: {
    functionName: "UI-RL-Partner-Config-TDS/TCSApplicable-Update-Click",
    message: "Changing TDS/TCS percentage",
  },
  UI_RL_PARTNER_CONFIG_TDS_TCS_APPLICABLE_CANCEL_CLICK: {
    functionName: "UI-RL-Partner-Config-TDS/TCSApplicable-Cancel-Click",
    message: "Cancel TDS/TCS percentage",
  },
  UI_RL_PARTNER_CONFIG_SANITIZER_CLICK: {
    functionName: "UI-RL-Partner-Config-sanitizer-Click",
    message: "Using sanitizer partner side",
  },
  UI_RL_PARTNER_CONFIG_SANITIZER_APPLY_CLICK: {
    functionName: "UI-RL-Partner-Config-sanitizer-Apply-Click",
    message: "Applying sanitizer partner side",
  },
  UI_RL_PARTNER_CONFIG_SANITIZER_CLOSE_CLICK: {
    functionName: "UI-RL-Partner-Config-sanitizer-Close-Click",
    message: "Closing sanitizer window without applying",
  },
  UI_RL_PARTNER_CONFIG_NEXT_ADD_CLICK: {
    functionName: "UI-RL-Partner-Config-Next-Add-Click",
    message: "Adding entry type in partner side",
  },
  UI_RL_PARTNER_CONFIG_SAVE_CLICK: {
    functionName: "UI-RL-Partner-Config-Save-Click",
    message: "Saving partner side manual config",
  },
  UI_RL_SET_RECON_PERIOD_CLICK: {
    functionName: "UI-RL-SetReconPeriod-Click",
    message: "Clicking to set Recon period",
  },
  UI_RL_SET_RECON_PERIOD_CONFIRM_CLICK: {
    functionName: "UI-RL-SetReconPeriod-Confirm-Click",
    message: "Setting Recon period",
  },
  UI_RL_RECONCILE_LEDGERS_CLICK: {
    functionName: "UI-RL-ReconcileLedgers-Click",
    message: "Reconciles ledgers",
  },
  UI_RL_DOWNLOAD_RESULTS_CLICK: {
    functionName: "UI-RL-DownloadResults-Click",
    message: "Download Results",
  },
  UI_RL_CUSTOMSHEETDROPDOWN_DOWNLOAD_CLICK: {
    functionName: "UI-RL-CustomSheetDropdown-Download-Click",
    message: "Click on Custom Sheet Dropdown’s Download Button",
  },
  UI_RL_RECONCILE_MANUALLY_CLICK: {
    functionName: "UI-RL-ReconcileManually-Click",
    message: "Clicking on Reconcile Manually button",
  },
  UI_RL_RECONCILE_MANUALLY_SUGGESTED_MATCHES_REFRESH_SUGGESTION_CLICK: {
    functionName: "UI-RL-ReconcileManually-SuggestedMatches-RefreshSuggestion-Click",
    message: "Using Refresh Suggestion feature",
  },
  UI_RL_RECONCILE_MANUALLY_SUGGESTED_MATCHES_VIEW_MORE_CLICK: {
    functionName: "UI-RL-ReconcileManually-SuggestedMatches-ViewMore-Click",
    message: "Viewing suggested matches",
  },
  UI_RL_RECONCILE_MANUALLY_SUGGESTED_MATCHES_VIEW_MORE_RECONCILE_CLICK: {
    functionName: "UI-RL-ReconcileManually-SuggestedMatches-ViewMore-Reconcile-Click",
    message: "Reconciling via suggested matches",
  },
  UI_RL_RECONCILE_MANUALLY_CHANGE_RECON_STATUS_APPLY_CLICK: {
    functionName: "UI-RL-ReconcileManually-ChangeReconStatus-Apply-Click",
    message: "Changing recon status manually",
  },
  UI_RL_RECONCILE_MANUALLY_RECONCILE_CLICK: {
    functionName: "UI-RL-ReconcileManually-Reconcile-Click",
    message: "Reconciling manually",
  },
  UI_RL_RECONCILE_MANUALLY_UNRECONCILE_CLICK: {
    functionName: "UI-RL-ReconcileManually-Unreconcile-Click",
    message: "Unreconciling manually",
  },
  UI_RL_RECONCILE_MANUALLY_BACK_CLICK: {
    functionName: "UI-RL-ReconcileManually-Back-Click",
    message: "Going back to the recon page",
  },
  UI_RL_RECONCILE_MANUALLY_CHANGES_DONE_ARROW_CLICK: {
    functionName: "UI-RL-ReconcileManually-ChangesDoneArrow-Click",
    message: "Seeing Changes done",
  },
  UI_RL_GENERATE_GAP_SUMMARY_CLICK: {
    functionName: "UI-RL-GenerateGapSummary-Click",
    message: "Generate Gap Summary",
  },
  UI_RL_SEND_RESULTS_TO_PARTNER_CLICK: {
    functionName: "UI-RL-SendRsultsToPartner-Click",
    message: "Send Results to Partner",
  },
  UI_RL_MISSED_COMBINATION_SAVE_CLICK: {
    functionName: "UI-RL-MissedCombination-Save-Click",
    message: "Update TDS and GST from missed combination and Save",
  },
  UI_RL_MISSED_COMBINATION_SAVE_AND_RECONCILE_CLICK: {
    functionName: "UI-RL-MissedCombination-SaveAndReconcile-Click",
    message: "Update TDS and GST from missed combination and Save and Reconcile Again",
  },
  UI_RL_PRE_RECON_TRIGGERED: {
    functionName: "UI-RL-Pre-Recon-Triggered",
    message: (issueCount) => `${issueCount} of issues/highlights present`,
  },
  UI_RL_PRE_RECON_CANCEL: {
    functionName: "UI-RL-Pre-Recon-Cancel",
    message: (issueCount) => `${issueCount} of issues/highlights present`,
  },
  UI_RL_PRE_RECON_CONTINUED: {
    functionName: "UI-RL-Pre-Recon-Continued",
    message: (issueCount) => `${issueCount} of issues/highlights present`,
  },
} as const;

export const uiLoggerNamesReconOutput = {
  UI_RL_RECONOUTPUT_RECONSUMMARYFORMAT_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-ReconSummaryFormat-Save-Click",
    message: "Click on Save button of Reconciliation Summary Format",
  },

  UI_RL_RECONOUTPUT_RECONSUMMARY_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-ReconSummary-Save-Click",
    message: "Click on Save button of Reconciliation Summary",
  },

  UI_RL_RECONOUTPUT_ANNEXURES_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-Annexures-Save-Click",
    message: "Click on Save button of Annexures",
  },

  UI_RL_RECONOUTPUT_NAMEINOUTPUT_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-NameInOutput-Save-Click",
    message: "Click on Save button of Name in Output",
  },

  UI_RL_RECONOUTPUT_CUSTOMCOLHEADERS_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-CustomColHeaders-Save-Click",
    message: "Click on Save button of Custom Column Headers",
  },

  UI_RL_RECONOUTPUT_DEFAULTRESULTFILE_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-DefaultResultFile-Save-Click",
    message: "Click on Save button of Default Result File",
  },

  UI_RL_RECONOUTPUT_OWNVSPARTNER_SAVE_CLICK: {
    functionName: "UI-RL-ReconOutput-OwnVsPartner-Save-Click",
    message: "Click on Save button of Own vs Partner",
  },
} as const;

export const fileTypeLogger = {
  pdf: "PDF",
  excel: "Excel",
} as const;

export const uiLoggerNamesWorkflow = {
  UI_WF_DB_DOWNLOAD_TASK_REPORT_CLICK: {
    functionName: "UI-WF-DB-DownloadTaskReport-Click",
    message: "Download the report of all partners",
  },
  UI_WF_DB_FILTER_CLICK: { functionName: "UI-WF-DB-Filter-Click", message: "Using filter button" },
  UI_WF_DB_FILTER_APPLY_CLICK: { functionName: "UI-WF-DB-Filter-Apply-Click", message: "Applying filter" },
  UI_WF_DB_PARTNER_SELECT_CLICK: {
    functionName: "UI-WF-DB-PartnerSelect-Click",
    message: "Selecting partner via hyperlink",
  },
  UI_WF_CREATE_TASK_CLICK: { functionName: "UI-WF-CreateTask-Click", message: "Create task" },
  UI_WF_DB_RECON_STATUS_BOTH_SIDE_LEDGER_PENDING_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-BothSideLedgerPending-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_PARTNER_LEDGER_PENDING_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-PartnerLedgerPending-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_OWN_LEDGER_PENDING_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-OwnLedgerPending-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_ISSUE_IN_LEDGER_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-IssueInLedger-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_YET_TO_START_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-YetToStart-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_RECON_IN_PROGRESS_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-ReconInProgress-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_MAKER_PASSED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-MakerPassed-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_CHECKER_REJECTED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-CheckerRejected-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_CHECKER_PASSED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-CheckerPassed-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_SENT_TO_APPROVER_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-SentToApprover-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_APPROVER_REJECTED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-ApproverRejected-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_APPROVER_PASSED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-ApproverPassed-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_TECHNICAL_ISSUE_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-TechnicalIssue-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_SAVE_TICKET_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-SaveTicket-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_DISCARD_TICKET_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-DiscardTicket-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_DROPPED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-Dropped-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_RECON_SENT_TO_PARTNER_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-ReconSentToPartner-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_WORK_IN_PROGRESS_ACTION_ITEMS_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-WorkInProgressActionItems-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_SIGNOFF_PENDING_WITH_PARTNER_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-SignoffPendingWithPartner-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_SIGNED_OFF_WITH_PARTNER_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-SignedOffWithPartner-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_ON_HOLD_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-OnHold-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_RECON_FINISHED_BY_USER_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-ReconFinishedByUser-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_BALANCE_CONFIRMED_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-BalanceConfirmed-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_DB_RECON_STATUS_CUSTOM_STATUS_CLICK: {
    functionName: "UI-WF-DB-ReconStatus-CustomStatus-Click",
    message: "Recon status change from dashboard table",
  },
  UI_WF_IT_SAVE_REMARKS_CLICK: { functionName: "UI-WF-IT-SaveRemarks-Click", message: "Saving in Remarks" },
  UI_WF_IT_ADD_FOLLOW_UP_MAIL_CLICK: {
    functionName: "UI-WF-IT-AddFollowUp-Mail-Click",
    message: "Using follow up option for Mail",
  },
  UI_WF_IT_ADD_FOLLOW_UP_CONVERSATION_CLICK: {
    functionName: "UI-WF-IT-AddFollowUp-Conversation-Click",
    message: "Using follow up option for Conversation",
  },
  UI_WF_IT_RECON_STATUS_BOTH_SIDE_LEDGER_PENDING_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-BothSideLedgerPending-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_PARTNER_LEDGER_PENDING_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-PartnerLedgerPending-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_OWN_LEDGER_PENDING_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-OwnLedgerPending-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_ISSUE_IN_LEDGER_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-IssueInLedger-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_YET_TO_START_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-YetToStart-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_RECON_IN_PROGRESS_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-ReconInProgress-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_MAKER_PASSED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-MakerPassed-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_CHECKER_REJECTED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-CheckerRejected-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_CHECKER_PASSED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-CheckerPassed-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_SENT_TO_APPROVER_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-SentToApprover-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_APPROVER_REJECTED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-ApproverRejected-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_APPROVER_PASSED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-ApproverPassed-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_TECHNICAL_ISSUE_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-TechnicalIssue-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_SAVE_TICKET_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-SaveTicket-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_DISCARD_TICKET_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-DiscardTicket-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_DROPPED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-Dropped-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_RECON_SENT_TO_PARTNER_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-ReconSentToPartner-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_WORK_IN_PROGRESS_ACTION_ITEMS_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-WorkInProgressActionItems-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_SIGNOFF_PENDING_WITH_PARTNER_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-SignoffPendingWithPartner-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_SIGNED_OFF_WITH_PARTNER_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-SignedOffWithPartner-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_ON_HOLD_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-OnHold-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_RECON_FINISHED_BY_USER_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-ReconFinishedByUser-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_BALANCE_CONFIRMED_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-BalanceConfirmed-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_IT_RECON_STATUS_CUSTOM_STATUS_CLICK: {
    functionName: "UI-WF-IT-ReconStatus-CustomStatus-Click",
    message: "Recon status change from inside ticket",
  },
  UI_WF_DB_BULKTASKS_ADDTASKS_DOWNLOADTEMPLATE_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-AddTasks-DownloadTemplate-Click",
    message: "Template downloaded for bulk tasks creation",
  },
  UI_WF_DB_BULKTASKS_ADDTASKS_UPLOADTEMPLATE_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-AddTasks-UploadTemplate-Click",
    message: "Template uploaded for bulk tasks creation",
  },
  UI_WF_DB_BULKTASKS_ADDTASKS_UPLOADTEMPLATE_CONFIRM_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-AddTasks-UploadTemplate-Confirm-Click",
    message: "Template uploaded for bulk tasks creation confirm button clicked",
  },
  UI_WF_DB_BULKTASKS_ADDTASKS_UPLOADTEMPLATE_DELETE_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-Addtasks-UploadTemplate-Delete-Click",
    message: "Template deleted for bulk task creation",
  },
  UI_WF_DB_BULKTASKS_UPDATETASKS_UPDATE_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-UpdateTasks-Update-Click",
    message: "Tasks updated in bulk",
  },
  UI_WF_DB_BULKTASKS_UPDATETASKS_UPDATE_CANCEL_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-UpdateTasks-Update-Cancel-Click",
    message: "Tasks not updated",
  },
  UI_WF_DB_BULKTASKS_SAVETASKS_SAVE_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-SaveTasks-Save-Click",
    message: "Tasks saved in bulk",
  },
  UI_WF_DB_BULKTASKS_SAVETASKS_CANCEL_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-SaveTasks-Cancel-Click",
    message: "Tasks not saved in bulk",
  },
  UI_WF_DB_BULKTASKS_DISCARDTASKS_DISCARD_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-DiscardTasks-Discard-Click",
    message: "Discarded tasks in bulk",
  },
  UI_WF_DB_BULKTASKS_DISCARDTASKS_CANCEL_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-DiscardTasks-Cancel-Click",
    message: "Tasks not discarded in bulk",
  },
  UI_WF_DB_BULKTASKS_CLEARTASKS_CLEAR_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-ClearTasks-Clear-Click",
    message: "Cleared tasks in bulk",
  },
  UI_WF_DB_BULKTASKS_CLEARTASKS_CANCEL_CLICK: {
    functionName: "UI-WF-DB-BulkTasks-ClearTasks-Cancel-Click",
    message: "Tasks not cleared in bulk",
  },
  UI_WF_DB_ACTIONS_VIEWATTACHMENTS_UPLOAD_CLICK: {
    functionName: "UI-WF-DB-Actions-ViewAttachments-Upload-Click",
    message: "Upload new attachments",
  },
  UI_WF_DB_ACTIONS_VIEWATTACHMENTS_DOWNLOAD_CLICK: {
    functionName: "UI-WF-DB-Actions-ViewAttachments-Download-Click",
    message: "Download tool attachments ",
  },
  UI_WF_DB_ACTIONS_VIEW_CUSTOMATTACHMENTS_DOWNLOAD_CLICK: {
    functionName: "UI-WF-DB-Actions-ViewAttachments-Download-Click",
    message: "Download custom attachments ",
  },
  UI_WF_DB_ACTIONS_VIEWATTACHMENTS_DELETE_CLICK: {
    functionName: "UI-WF-DB-Actions-ViewAttachments-Delete-Click",
    message: "Delete attachments",
  },
  UI_WF_DB_ACTIONS_EDIT_CLICK: {
    functionName: "UI-WF-DB-Actions-Edit-Click",
    message: "Clicked on edit task",
  },
  UI_WF_DB_ACTIONS_EDIT_SAVE_CLICK: {
    functionName: "UI-WF-DB-Actions-Edit-Save-Click",
    message: "Edited task successfully",
  },
} as const;

export enum uiLoggerBcPortal {
  ui_PpBcConfirmClick = "UI-PP-BC-CONFIRM-CLICK",
  ui_PpBcNotConfirmClick = "UI-PP-BC-NOTCONFIRM-CLICK",
  ui_PpBcCfDownloadClick = "UI-PP-BC-CF-DOWNLOAD-CLICK",
  ui_PpBcCfSignedUploadClick = "UI-PP-BC-CF-SIGNED-UPLOAD-CLICK",
  ui_PpBcCfSignedConfirmationUploadClick = "UI-PP-BC-CF-SIGNED-CONFIRMATION-UPLOAD-CLICK",
  ui_PpBcCfSignedViewClick = "UI-PP-BC-CF-SIGNED-VIEW-CLICK",
  ui_PpBcCfSignedDeleteClick = "UI-PP-BC-CF-SIGNED-DELETE-CLICK",
  ui_PpBcCfLedgerUploadClick = "UI-PP-BC-CF-LEDGER-UPLOAD-CLICK",
  ui_PpBcCfLedgerConfirmationUploadClick = "UI-PP-BC-CF-LEDGER-CONFIRMATION-UPLOAD-CLICK",
  ui_PpBcCfLedgerViewClick = "UI-PP-BC-CF-LEDGER-VIEW-CLICK",
  ui_PpBcCfLedgerDeleteClick = "UI-PP-BC-CF-LEDGER-DELETE-CLICK",
  ui_PpBcCfBackClick = "UI-PP-BC-CF-BACK-CLICK",
  ui_PpBcCfSubmitClick = "UI-PP-BC-CF-SUBMIT-CLICK",
  ui_PpBcCfRaiseIssueClick = "UI-PP-BC-CF-RAISE-ISSUE-CLICK",
  ui_PpBcCfRaiseIssueSubmitClick = "UI-PP-BC-CF-RAISE-ISSUE-SUBMIT-CLICK",
  ui_PpBcNcfBalanceClick = "UI-PP-BC-NCF-BALANCE-CLICK",
  ui_PpBcNcfDownloadClick = "UI-PP-BC-NCF-DOWNLOAD-CLICK",
  ui_PpBcNcfSignedUploadClick = "UI-PP-BC-NCF-SIGNED-UPLOAD-CLICK",
  ui_PpBcNcfSignedConfirmationUploadClick = "UI-PP-BC-NCF-SIGNED-CONFIRMATION-UPLOAD-CLICK",
  ui_PpBcNcfSignedViewClick = "UI-PP-BC-NCF-SIGNED-VIEW-CLICK",
  ui_PpBcNcfSignedDeleteClick = "UI-PP-BC-NCF-SIGNED-DELETE-CLICK",
  ui_PpBcNcfLedgerUploadClick = "UI-PP-BC-NCF-LEDGER-UPLOAD-CLICK",
  ui_PpBcNcfLedgerConfirmationUploadClick = "UI-PP-BC-NCF-LEDGER-CONFIRMATION-UPLOAD-CLICK",
  ui_PpBcNcfLedgerViewClick = "UI-PP-BC-NCF-LEDGER-VIEW-CLICK",
  ui_PpBcNcfLedgerDeleteClick = "UI-PP-BC-NCF-LEDGER-DELETE-CLICK",
  ui_PpBcNcfBackClick = "UI-PP-BC-NCF-BACK-CLICK",
  ui_PpBcNcfSubmitClick = "UI-PP-BC-NCF-SUBMIT",
  ui_PpBcNcfRaiseIssueClick = "UI-PP-BC-NCF-RAISE-ISSUE",
  ui_PpBcNcfRaiseIssueSubmitClick = "UI-PP-BC-NCF-RAISE-ISSUE-SUBMIT",
  ui_PpBcPostSubmitRaiseRequestClick = "UI-PP-BC-POST-SUBMIT-RAISE-REQUEST",
  ui_PpBcPostSubmitRaiseRequestSubmitClick = "UI-PP-BC-POST-SUBMIT-RAISE-REQUEST-SUBMIT",
  ui_Pp_SCF = "UI-PP-SCF",
}

export enum uiLoggerLrPortal {
  ui_PpLrUploadClick = "UI-PP-LR-UPLOAD-CLICK",
  ui_PpLrViewClick = "UI-PP-LR-VIEW-CLICK",
  ui_PpLrDeleteClick = "UI-PP-LR-DELETE-CLICK",
  ui_PpLrRaiseIssueClick = "UI-PP-LR-RAISE-ISSUE-CLICK",
  ui_PpLrRaiseIssueSubmitClick = "UI-PP-LR-RAISE-ISSUE-SUBMIT-CLICK",
  ui_PpLrSubmitClick = "UI-PP-LR-SUBMIT-CLICK",
  ui_PpLrPostSubmitRaiseRequestClick = "UI-PP-LR-POST-SUBMIT-RAISE-REQUEST-CLICK",
  ui_PpLrPostSubmitRaiseRequestSubmitClick = "UI-PP-LR-POST-SUBMIT-RAISE-REQUEST-SUBMIT-CLICK",
}

export const uiLoggerNamesCBBreakdown = {
  UI_RL_OWN_CB_DETAILS_CLICK: {
    functionName: "UI-RL-Own-CB-Details-Click",
    message: "Own Side CB Details",
  },
  UI_RL_OWN_CB_DETAILS_SAVE_CLICK: {
    functionName: "UI-RL-Own-CB-Details-Save-Click",
    message: "Own Side CB Details Save Button",
  },
  UI_RL_OWN_CB_DETAILS_KNOW_MORE_CLICK: {
    functionName: "UI-RL-Own-CB-Details-KnowMore-Click",
    message: "Own Side CB Details Know More Button",
  },
  UI_RL_OWN_CB_DETAILS_KNOW_MORE_COPY_CLICK: {
    functionName: "UI-RL-Own-CB-Details-KnowMore-Copy-Click",
    message: "Own Side CB Details Know More Button Copy Not read rows",
  },
  UI_RL_BP_CB_DETAILS_CLICK: {
    functionName: "UI-RL-BP-CB-Details-Click",
    message: "BP Side CB Details",
  },
  UI_RL_BP_CB_DETAILS_SAVE_CLICK: {
    functionName: "UI-RL-BP-CB-Details-Save-Click",
    message: "BP Side CB Details Save Button",
  },
  UI_RL_BP_CB_DETAILS_KNOW_MORE_CLICK: {
    functionName: "UI-RL-BP-CB-Details-KnowMore-Click",
    message: "BP Side CB Details Know More Button",
  },
  UI_RL_BP_CB_DETAILS_KNOW_MORE_COPY_CLICK: {
    functionName: "UI-RL-BP-CB-Details-KnowMore-Copy-Click",
    message: "BP Side CB Details Know More Button Copy Not read rows",
  },
} as const;

export const uiLoggerNamesCustomGapDescription = {
  UI_RL_ReconSummaryCalculation_CustomGapDescription_Save_Click: {
    functionName: "UI-RL-ReconSummaryCalculation-CustomGapDescription-Save-Click",
    message: "Saving Custom Gap Descriptions",
  },

  UI_RL_ReconSummaryCalculation_CustomGapDescription_EditPencil_Click: {
    functionName: "UI-RL-ReconSummaryCalculation-CustomGapDescription-EditPencil-Click",
    message: "Editing previously set custom gap description",
  },

  UI_RL_ReconSummaryCalculation_CustomGapDescription_Delete_Click: {
    functionName: "UI-RL-ReconSummaryCalculation-CustomGapDescription-Delete-Click",
    message: "Deleting previously set custom gap description",
  },

  UI_RL_ReconSummaryCalculation_CustomGapDescription_Add_Click: {
    functionName: "UI-RL-ReconSummaryCalculation-CustomGapDescription-Add-Click",
    message: "Adding new Custom Gap Description",
  },

  UI_RL_ReconSummaryCalculation_CustomGapDescription_Add_Update_Click: {
    functionName: "UI-RL-ReconSummaryCalculation-CustomGapDescription-Add-Update-Click",
    message: "Updating new added Custom Gap Description after addition through add button",
  },

  UI_RL_ReconSummaryCalculation_CustomGapDescription_EditPencil_Update_Click: {
    functionName: "UI-RL-ReconSummaryCalculation-CustomGapDescription-EditPencil-Update-Click",
    message: "Updating Custom Gap Description after editing through edit (pencil) button",
  },
} as const;
export const uiLoggerNamesChecklistAndNotes = {
  UI_RE_NOTES_CLICK: {
    functionName: "UI-RE-NOTES-CLICK",
    message: "Opened Notes",
  },
  UI_RE_NOTES_SEARCH_CLICK: {
    functionName: "UI-RE-NOTES-SEARCH-CLICK",
    message: "Searched Notes",
  },
  UI_RE_NOTES_ADD_CLICK: {
    functionName: "UI-RE-NOTES-ADD-CLICK",
    message: "Added a Note",
  },
  UI_RE_NOTES_DELETE_CLICK: {
    functionName: "UI-RE-NOTES-DELETE-CLICK",
    message: "Deleted a Note",
  },
  UI_RE_NOTES_PREVIEW_CLICK: {
    functionName: "UI-RE-NOTES-PREVIEW-CLICK",
    message: "Previewed a Note",
  },
  UI_RE_CHECKLIST_CLICK: {
    functionName: "UI-RE-CHECKLIST-CLICK",
    message: "Opened Checklist",
  },
  UI_RE_CHECKLIST_ADD_CLICK: {
    functionName: "UI-RE-CHECKLIST-ADD-CLICK",
    message: "Added an item",
  },
  UI_RE_CHECKLIST_MARK_CLICK: {
    functionName: "UI-RE-CHECKLIST-MARK-CLICK",
    message: "Marked an item",
  },
  UI_RE_CHECKLIST_UNMARK_CLICK: {
    functionName: "UI-RE-CHECKLIST-UNMARK-CLICK",
    message: "Unmarked an item",
  },
  UI_RE_CHECKLIST_PREVIEW_CLICK: {
    functionName: "UI-RE-CHECKLIST-PREVIEW-CLICK",
    message: "Previewed an item",
  },
  UI_RE_CHECKLIST_DELETE_CLICK: {
    functionName: "UI-RE-CHECKLIST-DELETE-CLICK",
    message: "Deleted an item",
  },
} as const;

export const uiLoggerNamesPartnerRiskManagement = {
  UI_MIS_PARTNERRISKMANAGEMENT_CLICK: {
    functionName: "UI-MIS-PartnerRiskManagement-Click",
    message: "Opens Partner Risk Management",
  },
  UI_MIS_PRM_ADDNEWREPORT_CLICK: {
    functionName: "UI-MIS-PRM-AddNewReport-Click",
    message: "Clicks on Add New Report",
  },
  UI_MIS_PRM_TASKREPOSITORY_CLICK: {
    functionName: "UI-MIS-PRM-TaskRepository-Click",
    message: "Clicks on Task Repository",
  },
  UI_MIS_PRM_ADDNEWREPORT_ADDREPORT_CLICK: {
    functionName: "UI-MIS-PRM-AddNewReport-AddReport-Click",
    message: "Adds new report successfully",
  },
  UI_MIS_PRM_ADDNEWREPORT_CANCEL_CLICK: {
    functionName: "UI-MIS-PRM-AddNewReport-Cancel-Click",
    message: "Cancels adding new report",
  },
  UI_MIS_PRM_MAINFILTER_CLICK: {
    functionName: "UI-MIS-PRM-MainFilter-Click",
    message: "Clicks on the main Filter",
  },
  UI_MIS_PRM_MAINFILTER_APPLY_CLICK: {
    functionName: "UI-MIS-PRM-MainFilter-Apply-Click",
    message: "Applies main filter",
  },
  UI_MIS_PRM_MOREOPTIONS_DOWNLOADREPORT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-DownloadReport-Click",
    message: "Downloads a single report",
  },
  UI_MIS_PRM_MOREOPTIONS_DELETEREPORT_DELETE_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-DeleteReport-Delete-Click",
    message: "Deletes a report",
  },
  UI_MIS_PRM_MOREOPTIONS_DELETEREPORT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-DeleteReport-Click",
    message: "Clicks on Delete report option",
  },
  UI_MIS_PRM_MOREOPTIONS_EDITREPORT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-EditReport-Click",
    message: "Clicks on Edit report option",
  },
  UI_MIS_PRM_MOREOPTIONS_EDITREPORT_SAVEREPORT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-EditReport-SaveReport-Click",
    message: "Saves report after editing",
  },
  UI_MIS_PRM_MOREOPTIONS_EDITREPORT_CANCEL_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-EditReport-Cancel-Click",
    message: "Cancels editing a report",
  },
  UI_MIS_PRM_MOREOPTIONS_DUPLICATEREPORT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-DuplicateReport-Click",
    message: "Clicks on Duplicate Report",
  },
  UI_MIS_PRM_MOREOPTIONS_DUPLICATEREPORT_ADDREPORT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-DuplicateReport-AddReport-Click",
    message: "Adds a report using duplicate report",
  },
  UI_MIS_PRM_MOREOPTIONS_DUPLICATEREPORT_CANCEL_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-DuplicateReport-Cancel-Click",
    message: "Cancels duplicating a report",
  },
  UI_MIS_PRM_REPORT_ADDFILTER_CLICK: {
    functionName: "UI-MIS-PRM-Report-AddFilter-Click",
    message: "Clicks on Add filter in a report",
  },
  UI_MIS_PRM_REPORT_ADDFILTER_APPLY_CLICK: {
    functionName: "UI-MIS-PRM-Report-AddFilter-Apply-Click",
    message: "Applies a filter in a report",
  },
  UI_MIS_PRM_REPORT_UPDATEREPORTPREVIEW_CLICK: {
    functionName: "UI-MIS-PRM-Report-UpdateReportPreview-Click",
    message: "Clicks on Update Report Preview",
  },
  UI_MIS_PRM_FULLSCREEN_CLICK: {
    functionName: "UI-MIS-PRM-FullScreen-Click",
    message: "Switches to full screen view",
  },
  UI_MIS_PRM_MAILREPORTS_CLICK: {
    functionName: "UI-MIS-PRM-MailReports-Click",
    message: "Opens Reports Mail Automation submodule",
  },
  UI_MIS_PRM_DOWNLOADALLSTATUSREPORTS_CLICK: {
    functionName: "UI-MIS-PRM-DownloadAllStatusReports-Click",
    message: "Download reports in bulk",
  },
  UI_MIS_PRM_DOWNLOADALLFUNNELREPORTS_CLICK: {
    functionName: "UI-MIS-PRM-DownloadAllFunnelReports-Click",
    message: "Download reports in bulk",
  },
  UI_MIS_PRM_MOREOPTIONS_REPORTVIEWSANDFILTERS_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-ReportViewsAndFilters-Click",
    message: "Clicks on Reports views and filters",
  },
  UI_MIS_PRM_MOREOPTIONS_REPORTVIEWSANDFILTERS_EDIT_CLICK: {
    functionName: "UI-MIS-PRM-MoreOptions-ReportViewsAndFilters-Edit-Click",
    message: "Clicks on edit report from report views and filters",
  },
} as const;

export const uiLoggerNamesReportsMailAutomation = {
  UI_MIS_REPORTSMAILAUTOMATION_CLICK: {
    functionName: "UI-MIS-ReportsMailAutomation-Click",
    message: "Opens Reports Mail Automation submodule",
  },
  UI_MIS_RMA_SENDQUICKEMAIL_CLICK: {
    functionName: "UI-MIS-RMA-SendQuickEmail-Click",
    message: "Clicks on Quick Email button",
  },
  UI_MIS_RMA_SENDQUICKEMAIL_SEND_CLICK: {
    functionName: "UI-MIS-RMA-SendQuickEmail-Send-Click",
    message: "Successfully sends a quick email",
  },
  UI_MIS_RMA_SENDAUTOMATEEMAIL_CLICK: {
    functionName: "UI-MIS-RMA-SendAutomateEmail-Click",
    message: "Clicks on Automated Email button",
  },
  UI_MIS_RMA_SENDAUTOMATEEMAIL_AUTOMATEEMAIL_CLICK: {
    functionName: "UI-MIS-RMA-SendAutomateEmail-AutomateEmail-Click",
    message: "Successfully sends an automated email",
  },
  UI_MIS_RMA_VIEWAUTOMATEDEMAIL_CLICK: {
    functionName: "UI-MIS-RMA-ViewAutomatedEmail-Click",
    message: "Clicks on an automated email template",
  },
  UI_MIS_RMA_VIEWAUTOMATEDEMAIL_SAVE_CLICK: {
    functionName: "UI-MIS-RMA-ViewAutomatedEmail-Save-Click",
    message: "Updates an automated email template",
  },
  UI_MIS_RMA_VIEWAUTOMATEDEMAIL_DELETE_CLICK: {
    functionName: "UI-MIS-RMA-ViewAutomatedEmail-Delete-Click",
    message: "Clicks to delete an automated email template",
  },
  UI_MIS_RMA_VIEWAUTOMATEDEMAIL_DELETE_DELETE_CLICK: {
    functionName: "UI-MIS-RMA-ViewAutomatedEmail-Delete-Delete-Click",
    message: "Deletes an automated email template",
  },
  UI_MIS_RMA_PAUSEAUTOMATEDEMAIL_ON_CLICK: {
    functionName: "UI-MIS-RMA-PauseAutomatedEmail-On-Click",
    message: "Pauses an automated email template",
  },
  UI_MIS_RMA_PAUSEAUTOMATEDEMAIL_OFF_CLICK: {
    functionName: "UI-MIS-RMA-PauseAutomatedEmail-Off-Click",
    message: "Unpauses an automated email template",
  },
} as const;

export const uiLoggerNameDisputeResolution = {
  UI_DR_CT_BulkMail_Send_Click: {
    functionName: "UI-DR-CT-BulkMail-Send-Click",
    message: "Clicked on Send on while sending Bulk Mails",
  },
  UI_DR_CT_RefreshStatus_Click: {
    functionName: "UI-DR-CT-RefreshStatus-Click",
    message: "Clicked on Refresh Status",
  },
  UI_DR_CT_SendViewMail_Click: {
    functionName: "UI-DR-CT-SendViewMail-Click",
    message: "Clicked on Send/View Mail",
  },
  UI_DR_CT_SendViewMail_Send_Click: {
    functionName: "UI-DR-CT-SendViewMail-Send-Click",
    message: "Clicked on Send from Send/View Mail",
  },
  UI_DR_CT_ViewRecon_Click: {
    functionName: "UI-DR-CT-ViewRecon-Click",
    message: "Clicked on View Recon",
  },
  UI_DR_CT_Attachments_Click: {
    functionName: "UI-DR-CT-Attachments-Click",
    message: "Clicked on View Attachments",
  },
  UI_DR_CT_EditTask_Save_Click: {
    functionName: "UI-DR-CT-EditTask-Save-Click",
    message: "Clicked on Save after clicking on Edit Task",
  },
  UI_DR_CT_History_Click: {
    functionName: "UI-DR-CT-History-Click",
    message: "Clicked on View History",
  },
  UI_DR_CT_Filter_Apply_Click: {
    functionName: "UI-DR-CT-Filter-Apply-Click",
    message: "Clicked on Apply in filter",
  },
  UI_DR_CT_DownloadReport_Click: {
    functionName: "UI-DR-CT-DownloadReport-Click",
    message: "Clicked on Dowload report in More options",
  },
  UI_DR_CT_SendFirstMail_Click: {
    functionName: "UI-DR-CT-SendFirstMail-Click",
    message: "Clicked on Send while Sending first mail for new communication",
  },
  UI_DR_CT_CcEmail_Click: {
    functionName: "UI-DR-CT-CCEmail-Click",
    message: "Click on cc email component",
  },
  UI_DR_CT_ToEmail_Click: {
    functionName: "UI-DR-CT-ToEmail-Click",
    message: "Click on to email component",
  },
} as const;

export const uiLoggerNamesPreProcessingLedger = (client_name: string) => ({
  UI_PPP_UPLOAD_CLICK: {
    functionName: `UI-PPP-${client_name}-Upload-Click`,
    message: "Click on Upload Ledger Button",
  },
  UI_PPP_PROCESS_CLICK: {
    functionName: `UI-PPP-${client_name}-Process-Click`,
    message: "Click on Process Button",
  },
  UI_PPP_DOWNLOAD_CLICK: {
    functionName: `UI-PPP-${client_name}-Download-Click`,
    message: "Click on Download Button",
  },
});

export const uiLoggerNamesTaskBoard = {
  UI_WF_TB_DOWNLOADTASKREPOSITORY_CLICK: {
    functionName: "UI-WF-TB-DownloadTaskRepository-Click",
    message: "Download the report of all partners",
  },
  UI_WF_TB_FILTER_CLICK: {
    functionName: "UI-WF-TB-Filter-Click",
    message: "Using filter button",
  },
  UI_WF_TB_FILTER_APPLY_CLICK: {
    functionName: "UI-WF-TB-Filter-Apply-Click",
    message: "Applying filter",
  },
  UI_WF_TB_PARTNERSELECTFROMTABLE_CLICK: {
    functionName: "UI-WF-TB-PartnerSelectFromTable-Click",
    message: "Selecting partner",
  },
  UI_WF_TB_PARTNERSELECTFROMDROPDOWN_CLICK: {
    functionName: "UI-WF-TB-PartnerSelectFromDropdown-Click",
    message: "Selecting partner",
  },
  UI_WF_TB_RECONSTATUS_BOTHSIDELEDGERPENDING_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-BothSideLedgerPending-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_PARTNERLEDGERPENDING_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-PartnerLedgerPending-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_OWNLEDGERPENDING_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-OwnLedgerPending-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_ISSUEINLEDGER_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-IssueInLedger-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_YETTOSTART_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-YetToStart-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_RECONINPROGRESS_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-ReconInProgress-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_MAKERPASSED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-MakerPassed-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_CHECKERREJECTED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-CheckerRejected-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_CHECKERPASSED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-CheckerPassed-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_SENTTOAPPROVER_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-SentToApprover-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_APPROVERREJECTED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-ApproverRejected-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_APPROVERPASSED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-ApproverPassed-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_TECHNICALISSUE_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-TechnicalIssue-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_SAVETICKET_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-SaveTicket-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_DISCARDTICKET_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-DiscardTicket-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_DROPPED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-Dropped-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_RECONSENTTOPARTNER_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-ReconSentToPartner-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_WORKINPROGRESSACTIONITEMS_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-WorkInProgressActionItems-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_SIGNOFFPENDINGWITHPARTNER_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-SignoffPendingWithPartner-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_SIGNEDOFFWITHPARTNER_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-SignedOffWithPartner-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_ONHOLD_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-OnHold-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_RECONFINISHEDBYUSER_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-ReconFinishedByUser-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_BALANCECONFIRMED_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-BalanceConfirmed-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_RECONSTATUS_CUSTOMSTATUS_CLICK: {
    functionName: "UI-WF-TB-ReconStatus-CustomStatus-Click",
    message: "Recon status change from table",
  },
  UI_WF_TB_ACTIONS_EDIT_CLICK: {
    functionName: "UI-WF-TB-Actions-Edit-Click",
    message: "Clicks on Edit option",
  },
  UI_WF_TB_ACTIONS_EDIT_SAVE_CLICK: {
    functionName: "UI-WF-TB-Actions-Edit-Save-Click",
    message: "Successfully edited a task",
  },
  UI_WF_TB_BULKTASKS_UPDATETASKS_UPDATE_UPDATE_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-UpdateTasks-Update-Update-Click",
    message: "Tasks updated in bulk",
  },
  UI_WF_TB_BULKTASKS_UPDATETASKS_UPDATE_CANCEL_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-UpdateTasks-Update-Cancel-Click",
    message: "Tasks not updated",
  },
  UI_WF_TB_BULKTASKS_SAVETASKS_SAVE_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-SaveTasks-Save-Click",
    message: "Tasks saved in bulk",
  },
  UI_WF_TB_BULKTASKS_SAVETASKS_CANCEL_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-SaveTasks-Cancel-Click",
    message: "Tasks not saved in bulk",
  },
  UI_WF_TB_BULKTASKS_DISCARDTASKS_DISCARD_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-DiscardTasks-Discard-Click",
    message: "Discarded tasks in bulk",
  },
  UI_WF_TB_BULKTASKS_DISCARDTASKS_CANCEL_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-DiscardTasks-Cancel-Click",
    message: "Tasks not discarded in bulk",
  },
  UI_WF_TB_BULKTASKS_CLEARTASKS_CLEAR_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-ClearTasks-Clear-Click",
    message: "Cleared tasks in bulk",
  },
  UI_WF_TB_BULKTASKS_CLEARTASKS_CANCEL_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-ClearTasks-Cancel-Click",
    message: "Tasks not cleared in bulk",
  },
  UI_WF_TB_ACTIONS_VIEWATTACHMENTS_UPLOAD_CLICK: {
    functionName: "UI-WF-TB-Actions-ViewAttachments-Upload-Click",
    message: "Upload new attachments",
  },
  UI_WF_TB_ACTIONS_VIEWATTACHMENTS_TOOL_DOWNLOAD_CLICK: {
    functionName: "UI-WF-TB-Actions-ViewAttachments-Download-Click",
    message: "Download tool attachments",
  },
  UI_WF_TB_ACTIONS_VIEWATTACHMENTS_CUSTOM_DOWNLOAD_CLICK: {
    functionName: "UI-WF-TB-Actions-ViewAttachments-Download-Click",
    message: "Download custom attachments",
  },
  UI_WF_TB_ACTIONS_VIEWATTACHMENTS_DELETE_CLICK: {
    functionName: "UI-WF-TB-Actions-ViewAttachments-Delete-Click",
    message: "Delete attachments",
  },
  UI_WF_TB_ACTIONS_VIEWHISTORY_CLICK: {
    functionName: "UI-WF-TB-Actions-ViewHistory-Click",
    message: "View history",
  },
  UI_WF_TB_DEFAULTVIEW_CLICK: {
    functionName: "UI-WF-TB-DefaultView-Click",
    message: "Selects Default View",
  },
  UI_WF_TB_MY_TASKS_CLICK: {
    functionName: "UI-WF-TB-MyTasks-Click",
    message: "Selects My Tasks view",
  },
  UI_WF_TB_STATUSSUMMARY_CLICK: {
    functionName: "UI-WF-TB-StatusSummary-Click",
    message: "Selects Status Summary view",
  },
  UI_WF_TB_RECONTASKS_CLICK: {
    functionName: "UI-WF-TB-ReconTasks-Click",
    message: "Selects Recon Tasks view",
  },
  UI_WF_TB_PARTNERCOMMUNICATION_OPEN_CLICK: {
    functionName: "UI-WF-TB-PartnerCommunication-Open-Click",
    message: "Opens Partner Communication from Task Board",
  },
  UI_WF_TB_ACTIONS_INVOICETASK_CLICK: {
    functionName: "UI-WF-TB-Actions-InvoiceTask-Click",
    message: "Clicks to invoice a task",
  },
  UI_WF_TB_ACTIONS_INVOICETASK_SAVE_CLICK: {
    functionName: "UI-WF-TB-Actions-InvoiceTask-Save-Click",
    message: "Invoiced a task successfully",
  },
  UI_WF_TB_BULKTASKS_INVOICETASKS_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-InvoiceTasks-Click",
    message: "Clicks to invoice tasks in bulk",
  },
  UI_WF_TB_BULKTASKS_INVOICETASKS_SAVE_CLICK: {
    functionName: "UI-WF-TB-BulkTasks-InvoiceTasks-Save-Click",
    message: "Tasks invoiced in Bulk",
  },
  UI_WF_TB_SAVEVIEW_SAVEASNEW_CLICK: {
    functionName: "UI-WF-TB-SaveView-SaveAsNew-Click",
    message: "Saves the view as a new view",
  },
  UI_WF_TB_SAVEVIEW_UPDATEEXISTING_CLICK: {
    functionName: "UI-WF-TB-SaveView-UpdateExisting-Click",
    message: "Updates the existing view",
  },
  UI_WF_TB_SAVEVIEW_CLICK: {
    functionName: "UI-WF-TB-SaveView-Click",
    message: "Clicks on Save View button",
  },
  UI_WF_TB_CUSTOMVIEW_CLICK: {
    functionName: "UI-WF-TB-CustomView-Click",
    message: "Selects a custom view",
  },
  UI_WF_TB_CUSTOMVIEW_DELETE_CLICK: {
    functionName: "UI-WF-TB-CustomView-Delete-Click",
    message: "Deletes a custom view",
  },
} as const;

// instramart sst rejected invoice and vendor portal

export const uiLoggerNamesVendorPortal = {
  UI_SST_IR_VENDOR_SUMMARY_CLICK: {
    functionName: "UI-SST-IR-Vendor-Summary-Click",
    message: "Clicks on vendor summary",
  },
  UI_SST_IR_VENDOR_TAKEACTION_CLICK: {
    functionName: "UI-SST-IR-Vendor-TakeAction-Click",
    message: "Initiates vendor take action",
  },
  UI_SST_IR_VENDOR_TAKEACTION_UPLOAD_CLICK: {
    functionName: "UI-SST-IR-Vendor-TakeAction-Upload-Click",
    message: "Uploads attachment in vendor take action",
  },
  UI_SST_IR_VENDOR_TAKEACTION_SUBMIT_CLICK: {
    functionName: "UI-SST-IR-Vendor-TakeAction-Submit-Click",
    message: "Submits vendor take action",
  },
  UI_SST_IR_VENDOR_TAKEACTION_VIEWATTACHMENT_CLICK: {
    functionName: "UI-SST-IR-Vendor-TakeAction-ViewAttachment-Click",
    message: "Views attachment in vendor take action",
  },
  UI_SST_IR_VENDOR_TAKEACTION_DELETEATTACHMENT_CLICK: {
    functionName: "UI-SST-IR-Vendor-TakeAction-DeleteAttachment-Click",
    message: "Deletes attachment in vendor take action",
  },
  UI_SST_IR_DOWNLOAD_REPORT_CLICK: {
    functionName: "UI-SST-IR-DownloadReport-Click",
    message: "Downloads the report",
  },
  UI_SST_IR_INVOICE_COPY_REQUIRED_CLICK: {
    functionName: "UI-SST-IR-InvoiceCopyRequired-Click",
    message: "Marks invoice copy as required",
  },
  UI_SST_IR_NEW_INVOICE_REQUIRED_CLICK: {
    functionName: "UI-SST-IR-NewInvoiceRequired-Click",
    message: "Marks new invoice as required",
  },
  UI_SST_IR_NAKAD_LOGO_CLICK: {
    functionName: "UI-SST-IR-NAKADlogo-Click",
    message: "Clicks on NAKAD logo",
  },
  UI_SST_EP_REQUEST_CALLBACK_CLICK: {
    functionName: "UI-SST-EP-RequestCallback-Click",
    message: "Clicks Request a Callback in Early Payment",
  },
  UI_SST_EP_GET_ONBOARDED_CLICK: {
    functionName: "UI-SST-EP-GetOnboarded-Click",
    message: "Clicks Get Onboarded in Early Payment",
  },
  UI_SST_EP_BANNER_REQUEST_CALLBACK_CLICK: {
    functionName: "UI-SST-EP-Banner-RequestCallback-Click",
    message: "Clicks Request a Callback on Early Payment banner",
  },
  UI_SST_EP_BANNER_VIEW_OFFER_CLICK: {
    functionName: "UI-SST-EP-Banner-ViewOffer-Click",
    message: "Clicks View Offer on Early Payment banner",
  },
  UI_SST_NAV_LEDGER_SUMMARY_CLICK: {
    functionName: "UI-SST-Nav-LedgerSummary-Click",
    message: "Clicks Ledger Summary in navigation menu",
  },
  UI_SST_NAV_INVOICE_REJECTION_CLICK: {
    functionName: "UI-SST-Nav-InvoiceRejection-Click",
    message: "Clicks Invoice Rejection in navigation menu",
  },
  UI_SST_NAV_RECONCILIATION_SUMMARY_CLICK: {
    functionName: "UI-SST-Nav-ReconciliationSummary-Click",
    message: "Clicks Reconciliation Summary in navigation menu",
  },
  UI_SST_NAV_RECON_DISPUTE_ENTRIES_CLICK: {
    functionName: "UI-SST-Nav-ReconDisputeEntries-Click",
    message: "Clicks Recon Dispute Entries in navigation menu",
  },
  UI_SST_NAV_RAISE_OTHER_ISSUES_CLICK: {
    functionName: "UI-SST-Nav-RaiseOtherIssues-Click",
    message: "Clicks Raise Other Issues in navigation menu",
  },
  UI_SST_NAV_EARLY_PAYMENT_CLICK: {
    functionName: "UI-SST-Nav-EarlyPayment-Click",
    message: "Clicks Early Payment in navigation menu",
  },
  UI_SST_NAV_FAQ_CLICK: {
    functionName: "UI-SST-Nav-FAQ-Click",
    message: "Clicks FAQ in navigation menu",
  },
};
export const uiLoggerNamesInvoiceRejection = {
  UI_SST_IR_SUMMARY_CLICK: {
    functionName: "UI-SST-IR-Summary-Click",
    message: "Clicks on invoice summary",
  },
  UI_SST_IR_TAKEACTION_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Click",
    message: "Initiates take action",
  },
  UI_SST_IR_TAKEACTION_UPLOAD_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Upload-Click",
    message: "Uploads attachment in take action",
  },
  UI_SST_IR_TAKEACTION_SUBMIT_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Submit-Click",
    message: "Submits take action",
  },
  UI_SST_IR_TAKEACTION_VIEWATTACHMENT_CLICK: {
    functionName: "UI-SST-IR-TakeAction-ViewAttachment-Click",
    message: "Views attachment in take action",
  },
  UI_SST_IR_TAKEACTION_DELETEATTACHMENT_CLICK: {
    functionName: "UI-SST-IR-TakeAction-DeleteAttachment-Click",
    message: "Deletes attachment in take action",
  },
  UI_SST_IR_TAKEACTION_APPROVE_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Approve-Click",
    message: "Approves from take action",
  },
  UI_SST_IR_TAKEACTION_REJECT_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Reject-Click",
    message: "Rejects from take action",
  },
  UI_SST_IR_BULKACTIONS_CLICK: {
    functionName: "UI-SST-IR-BulkActions-Click",
    message: "Opens bulk actions",
  },
  UI_SST_IR_BULKACTIONS_UPDATE_CLICK: {
    functionName: "UI-SST-IR-BulkActions-Update-Click",
    message: "Updates using bulk actions",
  },
  UI_SST_IR_FILTER_CLICK: {
    functionName: "UI-SST-IR-Filter-Click",
    message: "Opens invoice filter",
  },
  UI_SST_IR_FILTER_APPLY_CLICK: {
    functionName: "UI-SST-IR-Filter-Apply-Click",
    message: "Applies invoice filter",
  },
  UI_SST_IR_EDITDETAILS_CLICK: {
    functionName: "UI-SST-IR-EditDetails-Click",
    message: "Opens invoice edit details",
  },
  UI_SST_IR_EDITDETAILS_UPDATE_CLICK: {
    functionName: "UI-SST-IR-EditDetails-Update-Click",
    message: "Updates invoice details",
  },
  UI_SST_IR_VIEWHISTORY_CLICK: {
    functionName: "UI-SST-IR-ViewHistory-Click",
    message: "Views invoice history",
  },
  UI_SST_IR_TAKEACTION_COMMENTS_ADD_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Comments-Add-Click",
    message: "Adds comment in take action",
  },
  UI_SST_IR_TAKEACTION_COMMENTS_MARKASREAD_CLICK: {
    functionName: "UI-SST-IR-TakeAction-Comments-MarkAsRead-Click",
    message: "Marks comment as read in take action",
  },
  UI_SST_IR_COMMENTS_CLICK: {
    functionName: "UI-SST-IR-Comments-Click",
    message: "Opens comments section",
  },
  UI_SST_IR_COMMENTS_ADD_CLICK: {
    functionName: "UI-SST-IR-Comments-Add-Click",
    message: "Adds a comment",
  },
  UI_SST_IR_COMMENTS_MARKASREAD_CLICK: {
    functionName: "UI-SST-IR-Comments-MarkAsRead-Click",
    message: "Marks comment as read",
  },
};
